<template>
  <el-form ref="form" :inline="true" size="mini">
    <el-form-item>
      <el-tooltip placement="top">
        <div slot="content">Поиск по названию, балансу, ID</div>
        <el-input
          prefix-icon="el-icon-search"
          placeholder="Введите и нажмите Enter"
          v-model="localSearchString"
          @change="performSearch"
          clearable
        >
        </el-input>
      </el-tooltip>
    </el-form-item>
    <el-form-item>
      <SelectValute
        v-model="localValute"
        @input="performSearch"
        placeholder="Валюта"
      />
    </el-form-item>
    <el-form-item>
      <!-- <el-button type="success" size="medium" @click="performSearch"
                >Поиск</el-button
              > -->
      <el-button
        @click="getCsv"
        :loading="csvLoading"
        size="mini"
        icon="el-icon-download"
        >CSV</el-button
      >
      <el-button
        v-if="isFiltered"
        type="danger"
        size="mini"
        @click="resetSearch"
        >Сбросить фильтры</el-button
      >
    </el-form-item>
  </el-form>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { getBalanceAccountsCsv } from "@/api";
import SelectValute from "./SelectValute.vue";

export default {
  name: "DepositesFilterForm",
  data: () => ({ csvLoading: false }),
  components: {
    SelectValute
  },
  computed: {
    ...mapState("depositAccounts", ["searchString", "valute", "isFiltered"]),
    localSearchString: {
      get() {
        return this.searchString;
      },
      set(val) {
        this.changeSearchString({ searchString: val });
      }
    },
    localValute: {
      get() {
        return this.valute;
      },
      set(val) {
        this.changeValute({ valute: val });
      }
    }
  },
  methods: {
    ...mapActions("depositAccounts", [
      "changeSearchString",
      "changeValute",
      "performSearch",
      "resetSearch"
    ]),
    async getCsv() {
      try {
        this.csvLoading = true;
        const { data } = await getBalanceAccountsCsv({
          pagination: false,
          query: { $and: [{ is_deposit: true }] }
        });
        const fileURL = window.URL.createObjectURL(new Blob([data]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `deposites_${this.$dayjs().format("DD_MM_YYYY_HH_mm_ss")}.csv`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.csvLoading = false;
      }
    }
  },
  async mounted() {}
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/ui/DepositesFilterForm.vue